(() => {
  if (window.dreamLionGalleryReady) return;
  window.dreamLionGalleryReady = true;
  const dialog = document.createElement('dialog');
  dialog.className = 'gallery-dialog';
  dialog.setAttribute('aria-label', 'Product image gallery');
  const shell = document.createElement('div');
  shell.className = 'gallery-dialog__shell';
  const makeButton = (className, symbol) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.textContent = symbol;
    return button;
  };
  const close = makeButton('gallery-dialog__close', '×');
  const previous = makeButton('gallery-dialog__previous', '←');
  const next = makeButton('gallery-dialog__next', '→');
  const figure = document.createElement('figure');
  const image = document.createElement('img');
  const caption = document.createElement('figcaption');
  const counter = document.createElement('p');
  counter.className = 'gallery-dialog__counter';
  counter.setAttribute('aria-live', 'polite');
  counter.setAttribute('aria-atomic', 'true');
  const error = document.createElement('p');
  error.className = 'gallery-dialog__error';
  error.setAttribute('role', 'status');
  error.hidden = true;
  figure.append(image, caption);
  shell.append(close, previous, figure, next, counter, error);
  dialog.append(shell);
  document.body.append(dialog);
  let links = [];
  let index = 0;
  let trigger;
  let scrollState;
  let labels;
  const display = () => {
    const link = links[index];
    const source = link.querySelector('img');
    image.alt = source?.alt || '';
    image.src = link.href;
    caption.textContent = link.closest('figure')?.querySelector('figcaption')?.textContent || '';
    caption.hidden = !caption.textContent;
    counter.textContent = `${index + 1} / ${links.length}`;
    previous.hidden = next.hidden = links.length < 2;
    error.hidden = true;
  };
  image.addEventListener('error', () => {
    error.textContent = labels.error;
    error.hidden = false;
  });
  const move = delta => {
    index = (index + delta + links.length) % links.length;
    display();
  };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = shell.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    }
  });
  dialog.addEventListener('close', () => {
    if (!scrollState) return;
    document.body.style.overflow = scrollState.overflow;
    document.body.style.paddingRight = scrollState.paddingRight;
    window.scrollTo(scrollState.x, scrollState.y);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    scrollState = null;
    image.removeAttribute('src');
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('.product-gallery a[data-gallery-open], .incense-gallery a[data-gallery-open], .marble-gallery a[data-gallery-open]');
    if (!link || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const gallery = link.closest('.product-gallery, .incense-gallery, .marble-gallery');
    links = Array.from(gallery.querySelectorAll('a[data-gallery-open]')).filter(item => item.querySelector('img'));
    index = links.indexOf(link);
    if (index < 0) return;
    trigger = link;
    labels = {
      title: gallery.dataset.galleryLabel || 'Product image gallery',
      close: gallery.dataset.galleryClose || 'Close gallery',
      previous: gallery.dataset.galleryPrevious || 'Previous image',
      next: gallery.dataset.galleryNext || 'Next image',
      error: gallery.dataset.galleryError || 'This image could not be loaded.'
    };
    dialog.setAttribute('aria-label', labels.title);
    close.setAttribute('aria-label', labels.close);
    previous.setAttribute('aria-label', labels.previous);
    next.setAttribute('aria-label', labels.next);
    display();
    const scrollbar = window.innerWidth - document.documentElement.clientWidth;
    scrollState = { overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight, x: window.scrollX, y: window.scrollY };
    if (scrollbar > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    close.focus({ preventScroll: true });
  });
})();
